import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { useLeadForm } from "@/lib/lead";
import { TextField, PhoneField, MessageField } from "@/components/LeadFields";

export default function QuoteDialog({ open, onOpenChange, productSlug, leadType = "quote", title }) {
  const lf = useLeadForm(leadType, productSlug);
  const [doneId, setDoneId] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    const r = await lf.submit();
    if (r.ok) setDoneId(r.id);
    else if (r.error) toast.error(r.error);
  };

  const change = (v) => { onOpenChange(v); if (!v) setDoneId(null); };

  return (
    <Dialog open={open} onOpenChange={change}>
      <DialogContent className="sm:max-w-lg max-h-[92vh] overflow-y-auto bg-white border border-[#E2E8F0] rounded-sm" data-testid="quote-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-[#0F3D66]">{title || (leadType === "expert" ? "Talk to an Expert" : "Request a Quote")}</DialogTitle>
          <DialogDescription className="text-[#5F6B76]">A GMS sales engineer will respond within one business day.</DialogDescription>
        </DialogHeader>
        {doneId ? (
          <div className="py-6 text-center" data-testid="quote-success">
            <CheckCircle2 className="w-12 h-12 text-[#007BFF] mx-auto" strokeWidth={1.5} />
            <p className="font-heading font-bold text-[#0F3D66] text-xl mt-4">Thank you — enquiry received.</p>
            <p className="text-sm text-[#5F6B76] mt-2">Our sales engineer will contact you within 1 business day.</p>
            <p className="text-xs text-[#5F6B76] mt-3" data-testid="quote-success-ref">Reference: {doneId.slice(0, 8).toUpperCase()}</p>
            <button type="button" onClick={() => change(false)} className="gms-btn-primary mt-6" data-testid="quote-success-close">Close</button>
          </div>
        ) : (
          <form onSubmit={submit} noValidate className="grid grid-cols-2 gap-3" data-testid="quote-form">
            <TextField prefix="quote" k="name" lf={lf} label="Full name *" autoComplete="name" />
            <TextField prefix="quote" k="email" lf={lf} label="Business email *" type="email" autoComplete="email" />
            <PhoneField prefix="quote" lf={lf} />
            <TextField prefix="quote" k="company" lf={lf} label="Company" span="col-span-2" autoComplete="organization" />
            <MessageField prefix="quote" lf={lf} label="Tell us about your requirement (application, volume, timeline) *" />
            <button disabled={lf.busy} type="submit" className="col-span-2 gms-btn-primary justify-center disabled:opacity-60 disabled:cursor-not-allowed" data-testid="quote-submit">
              {lf.busy ? "Sending…" : (leadType === "expert" ? "Request Callback" : "Submit Enquiry")}
            </button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
